import { api } from '../api';
import { plural, SESSIONS } from '../format';
import { useApp } from '../store';
import { btn, mono, pill, pillGroup } from '../ui';

const LAYOUTS: Array<[number, string]> = [
  [1, '1 экран'],
  [4, '2×2'],
  [9, '3×3']
];

export function Rdp() {
  const app = useApp();
  const tiles = (app.selected.length ? app.selected : app.hosts).slice(0, app.rdpCount);
  const cols = app.rdpCount === 1 ? '1fr' : app.rdpCount === 4 ? 'repeat(2,1fr)' : 'repeat(3,1fr)';
  const gridCols = app.rdpCount === 1 ? 1 : app.rdpCount === 4 ? 2 : 3;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
        <span style={{ fontSize: 12, color: 'var(--ink3)' }}>
          Мультиэкран · {plural(tiles.length, SESSIONS)} · {app.sync ? 'синхронный ввод' : 'раздельный ввод'}
        </span>
        <span style={{ flex: 1 }} />

        <div style={pillGroup}>
          {LAYOUTS.map(([n, label]) => (
            <button key={n} onClick={() => app.setRdpCount(n)} style={pill(app.rdpCount === n)}>
              {label}
            </button>
          ))}
        </div>

        <button
          onClick={app.toggleSync}
          title="Синхронный ввод повторяет нажатия во всех открытых сессиях"
          style={{
            ...btn,
            padding: '7px 13px',
            borderRadius: 'var(--rs)',
            border: `1px solid ${app.sync ? 'var(--acc)' : 'var(--line)'}`,
            fontSize: 11.5,
            color: app.sync ? 'var(--acc)' : 'var(--ink3)',
            whiteSpace: 'nowrap'
          }}
        >
          Синхронный ввод: {app.sync ? 'вкл' : 'выкл'}
        </button>

        <button
          className="hov"
          onClick={() =>
            void api
              .downloadLauncher(tiles.map(h => h.id), gridCols)
              .catch(e => app.notify(String(e?.message ?? e)))
          }
          disabled={!tiles.length}
          title="PowerShell-скрипт: открывает выбранные сессии сеткой на рабочем столе"
          style={{
            ...btn,
            padding: '7px 13px',
            borderRadius: 'var(--rs)',
            border: '1px solid var(--line)',
            fontSize: 11.5,
            color: 'var(--ink2)',
            whiteSpace: 'nowrap'
          }}
        >
          Скачать лаунчер сетки
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 12 }}>
        {tiles.map((h, i) => (
          <div
            key={h.id}
            style={{
              border: '1px solid var(--line)',
              borderRadius: 'var(--r)',
              overflow: 'hidden',
              background: 'var(--code)',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 236
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 9,
                padding: '9px 12px',
                background: 'var(--panel)',
                borderBottom: '1px solid var(--line)'
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  background:
                    h.state === 'warn' ? 'var(--warn)' : h.state === 'offline' ? 'var(--ink4)' : 'var(--ok)'
                }}
              />
              <span style={{ ...mono, fontSize: 11.5 }}>{h.name}</span>
              <span style={{ flex: 1 }} />
              <span style={{ ...mono, fontSize: 10.5, color: 'var(--ink3)' }}>{h.ping} мс</span>
            </div>

            <a
              href={api.rdpUrl(h.id)}
              title="Открыть сессию в mstsc"
              style={{
                flex: 1,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                textDecoration: 'none'
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'radial-gradient(circle at 30% 20%, rgba(255,255,255,.05), transparent 60%)'
                }}
              />
              <span
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 6,
                  ...mono,
                  fontSize: 11,
                  color: 'var(--ink3)',
                  textAlign: 'center'
                }}
              >
                <span style={{ width: 34, height: 26, border: '1px solid var(--line2)', borderRadius: 3 }} />
                <span>
                  {h.ip} · сессия {i + 1}
                </span>
                <span style={{ color: 'var(--ink4)' }}>
                  {h.sessions.length ? h.sessions[0].user : 'нажмите — откроется mstsc'}
                </span>
              </span>
            </a>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '9px 12px',
                borderTop: '1px solid var(--line)',
                ...mono,
                fontSize: 10.5,
                color: 'var(--ink3)'
              }}
            >
              <span>CPU {h.cpu}%</span>
              <span>{h.temp ? h.temp + '°C' : '—'}</span>
              <span style={{ flex: 1 }} />
              <button
                onClick={() => app.toggleHost(h.id)}
                title="Убрать хост из выбора"
                style={{ ...btn, color: 'var(--bad)', fontSize: 10.5 }}
              >
                откл.
              </button>
            </div>
          </div>
        ))}
      </div>

      {!tiles.length && (
        <section
          style={{
            border: '1px solid var(--line)',
            borderRadius: 'var(--r)',
            background: 'var(--panel)',
            padding: '40px 20px',
            fontSize: 12.5,
            color: 'var(--ink3)'
          }}
        >
          Выберите хосты — они появятся здесь сеткой сессий.
        </section>
      )}

      <span style={{ fontSize: 11, color: 'var(--ink4)', maxWidth: 720, lineHeight: 1.6 }}>
        Картинка RDP внутри вкладки требует отдельного шлюза (Guacamole/FreeRDP). Пока консоль отдаёт готовые
        .rdp и лаунчер, который раскладывает mstsc сеткой — учётные данные берутся из «Диспетчера учётных
        данных» Windows.
      </span>
    </div>
  );
}
